import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { GetContractGroupTypeRequest } from '../../State/actions/mdqx/contract-group-type.actions';
import { getContractGroupTypeFetched } from '../../State/selectors/mdqx/selectors';
import { State } from '../../State';

@Injectable({
    providedIn: 'root',
})
export class ContractGroupTypeResolver implements Resolve<boolean> {
    constructor(private store: Store<State>) {
    }

    resolve() {
        const value$ = this.store.select(getContractGroupTypeFetched);

        value$
            .pipe(take(1))
            .subscribe(
                fetched =>
                    !fetched &&
                    localStorage.getItem('token') != null &&
                    this.store.dispatch(new GetContractGroupTypeRequest()),
            );

        return value$.pipe(
            filter(v => v),
            take(1),
        );
    }
}
